import reducerRegistry from 'core/lib/store/reducer-registry';
import {
  GET_MESSAGE_SETTINGS_OPEN,
  GET_MESSAGE_SETTINGS_OPEN_SUCCESS,
  GET_MESSAGE_SETTINGS_OPEN_ERROR,
  GET_THRID_CHAT_OPEN,
  GET_THRID_CHAT_OPEN_ERROR,
  GET_THRID_CHAT_OPEN_SUCCESS,
  GET_COM_AUTH,
  GET_COM_AUTH_SUCCESS,
  GET_COM_AUTH_ERROR,
  GET_MESSAGE_OPEN,
  GET_MESSAGE_OPEN_SUCCESS,
  GET_MESSAGE_OPEN_ERROR,
  GET_COM_NOEXPIRE_OPEN,
  GET_COM_NOEXPIRE_OPEN_SUCCESS,
  GET_COM_NOEXPIRE_OPEN_ERROR,
  AGENT_CONFIG, AGENT_CONFIG_SUCCESS, AGENT_CONFIG_ERROR,
} from "../action-types/userInfo";
import getMessageSettingsOpenReducer from '../reducers/messageSettingsOpen'
import api from '../apis/pc/guidance/guidance'
import apiCommon from '../apis/common/common'

reducerRegistry.register('messageSettingsOpen', getMessageSettingsOpenReducer)

export function getMessageSettingsOpen(callback) {
  return {
    types: [GET_MESSAGE_SETTINGS_OPEN, GET_MESSAGE_SETTINGS_OPEN_SUCCESS, GET_MESSAGE_SETTINGS_OPEN_ERROR],
    callAPI: () => api.getIsMessageOpen().then(res => {
      callback && callback(res)
      return res
    }).catch(err => err)
  };
}

export function getThirdChatAuth(callback) {
  return {
    types: [GET_THRID_CHAT_OPEN, GET_THRID_CHAT_OPEN_SUCCESS, GET_THRID_CHAT_OPEN_ERROR],
    callAPI: () => api.getThirdChatAuth().then(res => {
      callback && callback(res)
      return res
    }).catch(err => err)
  };
}

export function getComAuthInfo(callback) {
  return {
    types: [GET_COM_AUTH, GET_COM_AUTH_SUCCESS, GET_COM_AUTH_ERROR],
    callAPI: () => apiCommon.checkApply().then(res => {
      callback && callback(res)
      return res
    }).catch(err => err)
  };
}

export function getMessageOpenParams(callback) {
  return {
    types: [GET_MESSAGE_OPEN, GET_MESSAGE_OPEN_SUCCESS, GET_MESSAGE_OPEN_ERROR],
    callAPI: () => api.getMessageOpenParams().then(res => {
      callback && callback(res)
      return res
    }).catch(err => err)
  };
}

export function getCompanyNoExpire(callback) {
  return {
    types: [GET_COM_NOEXPIRE_OPEN, GET_COM_NOEXPIRE_OPEN_SUCCESS, GET_COM_NOEXPIRE_OPEN_ERROR],
    callAPI: () => api.getNoExpire().then(res => {
      callback && callback(res)
      return res
    }).catch(err => err)
  };
}

export function getAgentConfig(callback) {
  return {
    types: [AGENT_CONFIG, AGENT_CONFIG_SUCCESS, AGENT_CONFIG_ERROR],
    callAPI: () => callback(),
  };
}
